<template>
    <a v-bind="$attrs" :href="disabled ? null : href" :class="['dropdown-item', disabled && 'disabled']" :aria-disabled="disabled ? 'true' : null" @click="click"><slot /></a>
</template>
<script>
export default {
    name: "SbDropdownItem",
    emits: ["click"],
    inheritAttrs: false,
    inject: { sbDropdown: { default: null } },
    props: { href: { type: String, default: "#" }, disabled: { type: Boolean, default: false } },
    methods: {
        click(event) {
            if (this.disabled) { event.preventDefault(); return; }
            this.$emit("click", event);
            this.sbDropdown?.select();
        },
    },
};
</script>
